import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course05 from "../../../course/course-05/course";
import lesson0503 from "../../../lesson/course-05/lesson-03/lesson";
import lesson0508 from "../../../lesson/course-05/lesson-08/lesson";
import lesson0509 from "../../../lesson/course-05/lesson-09/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "2867516d-a3a6-4c11-8947-fb6148cc5419",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0503),
    lesson: lesson0503,
  },
  {
    id: "894cd297-6de7-4616-ae95-2a3b4b42c635",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0508),
    lesson: lesson0508,
  },
  {
    id: "d211ee86-0a8a-4243-a5c3-81d58cf4c311",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0509),
    lesson: lesson0509,
  },
];

export default lessonLinks;
